import { radioAnatomy } from '@chakra-ui/anatomy';
import { createMultiStyleConfigHelpers, defineStyle } from '@chakra-ui/react';

const { definePartsStyle, defineMultiStyleConfig } =
  createMultiStyleConfigHelpers(radioAnatomy.keys);

const baseStyle = definePartsStyle({
  control: {
    _checked: {
      borderColor: 'black',
      background: 'black',
    },
  },
  container: {
    _checked: {
      px: 2,
      py: 1,
      borderRadius: 'md',
    },
  },
  label: {
    width: '100%',
  },
});

const sizes = {
  md: definePartsStyle({
    label: { fontSize: 'sm' },
  }),
  xl: definePartsStyle({
    control: defineStyle({
      w: '8',
      h: '8',
    }),
  }),
};

const teal = definePartsStyle({
  control: {
    _checked: {
      borderWidth: 2,
      borderColor: 'teal.500',
      background: 'teal.500',
      rounded: 'full',
    },
  },
});

const error = definePartsStyle({
  control: {
    _checked: {
      borderWidth: 2,
      borderColor: 'red.500',
      background: 'red.500',
      rounded: 'full',
      _hover: {
        borderColor: 'red.500',
        background: 'red.500',
      },
    },
  },
  label: {
    _checked: {
      color: 'red.500',
      fontWeight: 'bold',
    },
  },
  container: {
    _checked: {
      bgColor: 'red.100',
    },
  },
});

export const radioTheme = defineMultiStyleConfig({
  baseStyle,
  sizes,
  variants: { teal, error },
});
